import React from "react";
import AppLayout from "../../../layouts/AppLayout";
import { Button, Dropdown, Menu, MenuProps } from "antd";
import BackIcon from "../../../assets/icons/BackIcon";
import LeftArrowIcon from "../../../assets/icons/LeftArrowIcon";
import { Link, useNavigate } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import {
  GetSupplierPaymentHistoryParams,
  TransactionsDetails,
} from "../../../types/statements";
import { addKeyInArray } from "../../../utils/utils";
import moment from "moment";
import ThreeDotActionIcon from "../../../assets/icons/ThreeDotActionIcon";
import EyeIcon from "../../../assets/icons/EyeIcon";
import DownloadIcon from "../../../assets/icons/DownloadIcon";
import useModal from "../../../hooks/useModal";
import SuccessModal from "../../../components/Modal/SuccessModal";

export default function ReconcileDetails() {
  const navigate = useNavigate();
  const loading = false;
  const { open, handleOpen, handleClose } = useModal<
    TransactionsDetails | undefined
  >();
  const {
    page,
    limit,
    handlePagination,
    handleLimit,
    filter,
    handleFilter,
    handleSearch,
    keyword,
  } = useTable<GetSupplierPaymentHistoryParams>();

  // const handleMenuClick: MenuProps["onClick"] = ({ key }) => {
  //   if (key === "view") {
  //     console.log("View Statement clicked");
  //     // Add your logic here
  //   } else if (key === "upload") {
  //     console.log("Upload clicked");
  //     // Add your logic here
  //   }
  // };

  const menu = (
    <Menu>
      <Menu.Item>
        <div className="flex items-center gap-2">
          <EyeIcon />
          <span>View Statement</span>
        </div>
      </Menu.Item>
      <Menu.Item onClick={() => handleOpen({ type: "VIEW" })}>
        <div className="flex items-center gap-2">
          <DownloadIcon />
          <span>Download Statement</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  const columns: ColumnsType<DataType> = [
    {
      title: <div className="text-nowrap">Bank Transaction Details</div>,
      key: "bankTransactionDetails",
      dataIndex: "bankTransactionDetails",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Uploaded Date</div>,
      key: "uploadedDate",
      dataIndex: "createdAt",
      align: "center",
      render: (date) => (
        <span className="text-nowrap">
          {date ? moment(date).format("DD/MM/YYYY") : "-"}
        </span>
      ),
    },
    {
      title: <div className="text-nowrap">Uploaded Time</div>,
      key: "uploadedTime",
      dataIndex: "createdAt",
      align: "center",
      render: (date) => (
        <span className="text-nowrap">
          {date ? moment(date).format("hh:mm A") : "-"}
        </span>
      ),
    },
    {
      title: <div className="text-nowrap">Verification Status</div>,
      key: "verificationStatus",
      dataIndex: "verificationStatus",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Uploaded File</div>,
      key: "uploadedFile",
      dataIndex: "uploadedFile",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Bank Trx. ID</div>,
      key: "bankTrxId",
      dataIndex: "bankTrxId",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Sheba Trx. ID</div>,
      key: "shebaTrxId",
      dataIndex: "shebaTrxId",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">MR ID</div>,
      key: "mrId",
      dataIndex: "mrId",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Amount</div>,
      key: "amount",
      dataIndex: "amount",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: <div className="text-nowrap">Status</div>,
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: () => (
        <Dropdown overlay={menu} trigger={["click"]}>
          <div className="cursor-pointer">
            <ThreeDotActionIcon />
          </div>
        </Dropdown>
      ),
    },
  ];

  return (
    <>
      <AppLayout title="Reconcile Details">
        {open.type === "VIEW" && (
          <SuccessModal
            open={open.open}
            type={open.type}
            data={open.data}
            handleClose={handleClose}
            title="Download Successful"
            buttonText="Okay"
          />
        )}

        <div className="self-stretch justify-start !text-[#2D3643] text-4xl font-medium mb-5">
          <Button
            className="text-gray-600"
            icon={<LeftArrowIcon />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </div>

        <div className="flex items-center gap-2">
          <div className="w-14 h-14 rounded-full ">
            <img
              src="https://t3.ftcdn.net/jpg/07/03/40/68/360_F_703406856_zjU834tWjYAB8Rtr2OOXGdLgdVH0cpiS.jpg"
              alt="Dealer"
              className="w-full h-full object-cover rounded-full "
            />
          </div>
          <div>
            <div className="justify-start text-zinc-700 text-2xl font-semibold">
              Natinal Baird
            </div>
            <div className="flex-1 text-slate-500">Admin</div>
          </div>
        </div>

        <div className="mt-4">
          <CustomTable
            columns={columns}
            className="text-header overflow-auto mt-4"
            loading={loading}
            handleLimit={handleLimit}
            handlePagination={handlePagination}
            limit={limit}
            dataList={addKeyInArray(data)}
            page={page}
            bordered={false}
            total={120}
            hideSpace
            paginationClassnames="dark:bg-primaryBackground bg-white dark:border-others-body border-others-borderLight py-4 px-4 relative"
            // showTotalPage
          />
        </div>
      </AppLayout>
    </>
  );
}

type DataType = {
  key: string;
  bankTransactionDetails: string;
  createdAt: string;
  verificationStatus: string;
  uploadedFile: string;
  bankTrxId: string;
  shebaTrxId: string;
  mrId: string;
  amount: string | number;
  status: string;
};

const data: DataType[] = [
  {
    key: "1",
    bankTransactionDetails: "Salary for May",
    createdAt: "2025-05-18T14:30:00Z",
    verificationStatus: "Verified",
    uploadedFile: "may_salary_statement.pdf",
    bankTrxId: "BANK123456",
    shebaTrxId: "SHEBA987654",
    mrId: "MR001",
    amount: 50000,
    status: "Completed",
  },
  {
    key: "2",
    bankTransactionDetails: "Project Bonus",
    createdAt: "2025-05-15T10:15:00Z",
    verificationStatus: "Pending",
    uploadedFile: "bonus_statement.pdf",
    bankTrxId: "BANK654321",
    shebaTrxId: "SHEBA123987",
    mrId: "MR002",
    amount: 10000,
    status: "Pending",
  },
];
